import * as constants from '@/common/constants';

export default {
    state: {
        menuRemindNum: constants.VUEX_REMIND_NUM_DATA,
        navNumData:constants.VUEX_NAV_NUM_DATA
    },
    mutations: {
        [constants.VUEX_MUTATIONS_REMIND_NUM]: (state, menuRemindNum) => {
            state.menuRemindNum = menuRemindNum;
        },
        [constants.VUEX_MUTATIONS_NAV_NUM_DATA]: (state, navNumData) => {
            state.navNumData = navNumData;
        }
    },
    actions: {
        [constants.VUEX_ACTIONS_REMIND_NUM] ({ commit }, nm) {
            commit(constants.VUEX_MUTATIONS_REMIND_NUM, nm);
        },
        [constants.VUEX_ACTIONS_NAV_NUM_DATA] ({ commit }, navNumData) {
            commit(constants.VUEX_MUTATIONS_NAV_NUM_DATA, navNumData);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/store-menu-remind.js